<template>
  <v-flex xs12 lg10 offset-lg-1 p-3 d-flex text-xs-center>
    <v-layout row wrap p-3>
      <v-flex
        xs12
        p-3
        text-xs-left
        class="minusMarginTop-20 minusMarginBottom-30"
      >
        <h3 v-if="loadSubscriptions">Biztos Beszéd Egyszerűen</h3>
        <h3 v-else>Próbaleckék</h3>
      </v-flex>

      <v-layout row class="mobileRowWidth scrollableX">
        <v-flex
          v-show="loadSubscriptions"
          xs12
          md3
          p-3
          text-xs-left
          v-for="(course, index) in courses"
          :key="'sl-' + index"
          class="chooserLessonTile minusMarginBottom-30"
          @click="goToStepField(course.id, course.subscription.id)"
        >
          <div v-show="course.subscription.active" class="card">
            <div class="card-content">
              <div class="banner-holder">
                <div
                  class="banner"
                  data-height="20vh"
                  data-height-expanded="45vh"
                  :style="{
                    'background-image':
                      'url(' +
                      apiUrl +
                      '/uploads/picture/' +
                      course.picture.filename +
                      ')',
                  }"
                ></div>
              </div>
              <div class="container-fluid content-holder">
                <div
                  class="inner-content"
                  data-position="20vh"
                  data-position-expanded="40vh"
                >
                  <div class="info-holder">
                    <div class="date-category">TRÉNING {{ index+1 }}.</div>
                    <!--<div v-if="index == 0" class="date-category">-->
                    <!--  TRÉNING I.-->
                    <!--</div>-->
                    <!--<div v-else-if="index == 1" class="date-category">-->
                    <!--  TRÉNING II.-->
                    <!--</div>-->
                    <!--<div v-else class="date-category">TRÉNING III.</div>-->
                  </div>
                  <h2 class="title">{{ course.title }}</h2>
                  <div class="description">
                    <p>{{ course.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-flex>

        <v-flex
          v-show="loadFreeLessons"
          xs12
          md3
          p-3
          text-xs-left
          v-for="(freeLesson, index) in freeLessons"
          :key="'fl-' + index"
          class="chooserLessonTile minusMarginBottom-30"
          @click="goToLesson(freeLesson.id)"
        >
          <div class="card">
            <div class="card-content">
              <div class="banner-holder">
                <div
                  class="banner"
                  data-height="20vh"
                  data-height-expanded="45vh"
                  :style="{
                    'background-image': 'url(' + freeLesson.image + ')',
                  }"
                ></div>
              </div>
              <div class="container-fluid content-holder">
                <div
                  class="inner-content"
                  data-position="20vh"
                  data-position-expanded="40vh"
                >
                  <div class="info-holder">
                    <div class="date-category">{{ freeLesson.subTitle }}</div>
                  </div>
                  <h2 class="title">{{ freeLesson.title }}</h2>
                  <div class="description">
                    <p>{{ freeLesson.description }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>

      <v-flex xs12 p-3 text-xs-left class="minusMarginBottom-30">
        <h3>Korlátozott ideig tartó ajánlat <br /></h3>

        <p class="text-muted minusMarginTop-10">
          Tanfolyamok, amelyek a lényeget adják, reflexszerű nyelvhasználatot.
        </p>
      </v-flex>

      <v-layout row class="mobileRowWidth">
        <v-flex
          v-show="loadFreeLessons"
          xs12
          md3
          p-3
          text-xs-left
          class="chooserLessonTile minusMarginBottom-60"
          @click="goToOffer('https://e-egyetem.hu/csomagok')"
        >
          <div class="card cardOnlyImg">
            <div class="card-content">
              <div class="banner-holder">
                <div
                  class="banner"
                  data-height="20vh"
                  data-height-expanded="45vh"
                  :style="{
                    'background-image':
                      'url(' + require('@/assets/img/uk.png') + ')',
                  }"
                ></div>
              </div>
              <div class="container-fluid content-holder">
                <div
                  class="inner-content"
                  data-position="20vh"
                  data-position-expanded="40vh"
                >
                  <div class="description">
                    <p>Válassz angol csomagot</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-flex>

        <v-flex
          xs12
          md3
          p-3
          text-xs-left
          class="chooserLessonTile minusMarginBottom-60"
          @click="goToOffer('https://e-egyetem.hu/csomagok')"
        >
          <div class="card cardOnlyImg">
            <div class="card-content">
              <div class="banner-holder">
                <div
                  class="banner"
                  data-height="20vh"
                  data-height-expanded="45vh"
                  :style="{
                    'background-image':
                      'url(' + require('@/assets/img/de.png') + ')',
                  }"
                ></div>
              </div>
              <div class="container-fluid content-holder">
                <div
                  class="inner-content"
                  data-position="20vh"
                  data-position-expanded="40vh"
                >
                  <div class="description">
                    <p>Válassz német csomagot</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-flex>
      </v-layout>

      <div
        class="chooserMessageButton clickable"
        @click="$router.push({ name: 'messages' })"
      >
        <div class="row">
          <div class="col-3">
            <v-icon color="white" class="chooserMessageButtonIcon">
              email
            </v-icon>
          </div>
          <div class="col-9">
            <p class="pt-3">
              Kérdésed akadt? <br />
              Üzenj nekünk!
            </p>
          </div>
        </div>
      </div>
    </v-layout>
  </v-flex>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  data: function () {
    return {
      subscriptions: "",
      courses: "",
      freeLessons: "",
      offerUrl: "https://index.hu",
      apiUrl: this.$store.getters.getApiUrl,
      sapBuyerLink: this.$store.getters.getSAPBuyerLink,
      loadFreeLessons: false,
      loadSubscriptions: false,
      unreadMessageTitle: this.$store.getters.getUnreadMessageTitle,
      unreadMessageShow: false,
    };
  },
  methods: {
    getChooserData() {
      this.$store.commit("setCourseId", {
        courseId: 0,
      });

      this.$store.commit("setSubscriptionId", {
        subscriptionId: 0,
      });

      this.$store.commit("updateLastQuestion", {
        lastQuestionId: 0,
      });

      axios
        .post(this.$store.getters.getApiUrl + "/api/chooser", {
          token: this.$store.getters.getToken,
          userId: this.$store.getters.currentUser.id,
        })
        .then((response) => {
          console.log('chooser - resp: ', response.data);
          this.$data.subscriptions = response.data.subscriptions;
          this.$data.courses = response.data.courses;
          this.$data.freeLessons = response.data.freeLessons;

          if (response.data.subscriptions.length < 1) {
            this.loadFreeLessons = true;
            this.loadSubscriptions = false;
          } else {
            this.loadFreeLessons = false;
            this.loadSubscriptions = true;
          }

          //Check message
          this.checkMessage();
        })
        .catch((error) => {
          if (error.length > 0) {
            // console.log('stepfield- error: ', error);
          }
        });
    },
    checkMessage() {
      //Get the curent user data
      this.$data.user = this.$store.getters.currentUser;

      //Check the unreaded messages
      axios
        .post(this.$store.getters.getApiUrl + "/api/message/checkMessage", {
          token: this.$store.getters.getToken,
          userId: this.$data.user.id,
        })
        .then((response) => {
          // console.log('checkmessage - response: ', response.data);

          //Load the responsed data
          this.$data.unreadMessageTitle = response.data.unreadFirstMessageTitle;

          if (this.$data.unreadMessageTitle.length > 1) {
            this.$data.unreadMessageShow = true;
          } else {
            this.$data.unreadMessageShow = false;
          }
        })
        .catch((error) => {
          if (error.length > 0) {
            console.log("leaderBoard - error: ", error);
          }
        });
    },
    goToStepField(courseId, subscriptionId) {
      this.$store.commit("setCourseId", {
        courseId: courseId,
      });

      this.$store.commit("setSubscriptionId", {
        subscriptionId: subscriptionId,
      });

      this.$router.push({ name: "home" });
    },
    goToLesson(lessonId) {
      this.$store.commit("setCurrentLessonId", {
        currentLessonId: lessonId,
      });

      axios
        .post(this.$store.getters.getApiUrl + "/api/lesson/prologue/check", {
          token: this.$store.getters.getToken,
          lessonId: lessonId,
        })
        .then((response) => {
          //Check prologue state
          if (response.data.prologue_load) {
            this.$router.push({
              name: "prologue",
              params: { lessonId: lessonId },
            });
          } else {
            this.$router.push({
              name: "question",
              params: { lessonId: lessonId },
            });
          }
        })
        .catch((error) => {
          if (error.length > 0) {
            console.log("chooser - lesson - loading - error: ", error);
          }
        });
    },
    goToOffer(url) {
      window.open(url, "_blank");
    },
    goToBuyLink() {
      window.open(this.$data.sapBuyerLink, "_blank");
    },
    goToMessages() {
      this.$router.push({ name: "messages" });
    },
  },
  created: function () {
    this.getChooserData();
  },
};
</script>
